import { createContext, useContext } from 'react';
import { confirmDiscard } from '@/stores/confirm';
import { useIsUnsaved, useUnsaved } from '@/stores/unsaved';

/** The unsaved-work id of the FormPanel or ComposePanel around a component. */
export const UnsavedFormContext = createContext<string | null>(null);

/**
 * Wraps a form's Cancel so that, when something has been typed, it asks
 * before throwing it away.
 */
export function useGuardedCancel(onCancel: () => void): () => void {
  const formId = useContext(UnsavedFormContext);
  const unsaved = useIsUnsaved(formId ?? '');
  return () => {
    if (!unsaved) return onCancel();
    void confirmDiscard().then((ok) => ok && onCancel());
  };
}

/**
 * For a form that stays open after saving (Settings › Company): call the
 * returned function once saved or reset, so leaving no longer asks.
 */
export function useMarkSaved(): () => void {
  const formId = useContext(UnsavedFormContext);
  const mark = useUnsaved((s) => s.mark);
  return () => {
    if (formId) mark(formId, false);
  };
}
